import * as EXPERIMENTS from './experiments.json';

// get an up-to-date experiments object with "make refresh-experiments"
export default EXPERIMENTS.reduce((memo, name) => {
  memo[name.toUpperCase()] = name;
  return memo;
}, {}) as any;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/src/experiments.ts